module.exports = __webpack_public_path__ + "static/6-Ruoskis-Egzaminui-is-anksto-c75fe8ce596a4a20dc6df05c1469331d.svg";